<template>
    <div class="main_container">
        <div class="layout_split">
            <RightWing :index="0" :score="score" />
            <div class="main_area mobile_margin">
                <div style="opacity:0; font-size:10px;">space</div>

                <div class="view_title">{{$t('title_section_view')}}</div>

                <div class="flex_container">
                    <div v-for="section in sectionList" :key="section.index"
                        class="flex_item"
                        @click="next(section.index)">
                        <!-- @click="touchSection(section.index, $event)"> -->
                        {{section.title}}
                        <!-- <br>{{section.complete}} -->
                        <div style="text-align:center;"><img :src="section.img" width="130"></div>
                    </div>
                </div>
                
                <!-- <div class="bottom_btn_container">
                    <div class="bottom_one_btn" @click="next">{{$t('btn_section_list_view')}}</div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import RightWing from '../components/RightWingView.vue'
export default {
    name: 'SectionListView',

    components: {
        'RightWing': RightWing
    },

    data() {
        return {
            sectionList: [
                {'index': 0, 'title': '사회와 법률', complete: '', 'img': require('../assets/img/section_1.png')},
                {'index': 1, 'title': '건강과 과학', complete: '', 'img': require('../assets/img/section_2.png')},
                {'index': 2, 'title': '문화와 예술', complete: '', 'img': require('../assets/img/section_3.png')},
                {'index': 3, 'title': '지구 환경', complete: '', 'img': require('../assets/img/section_4.png')},
                {'index': 4, 'title': '한국사', complete: '', 'img': require('../assets/img/section_5.png')},
            ],
            selectedSection: null,
            currentPlay: null,
            score: null,
        }
    },

    mounted() {
        // TODO complete 계산
        // TODO json 데이터 기반으로 변경
        this.score = this.$getCurrentGame().score
    },

    methods: {
        touchSection: function(index, e) {
            for(const child of e.target.parentElement.childNodes) {
                child.style.backgroundColor = '#FFFFFF'
            }
            e.target.style.backgroundColor = '#DF5D5B'
            this.selectedSection = index
        },

        next: function(index) {
            this.selectedSection = index
            // if(this.selectedSection == null) {
            //     return
            // }
            let currentGame = this.$getCurrentGame()
            currentGame.selectedSection = this.selectedSection
            this.$setCurrentGame(currentGame)
            this.$router.push('/articleList')
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main_area {
    width:100%;
    background-color:#e5e5e5;
    /* background-color: red; */
    /* height: 100vh - 20px; */
    /* overflow: auto; */
}

/* pc */
@media screen and (min-width: 415px) {
    .flex_container {
        margin: 30px 130px;
        padding: 30px;
        background-color: lightgray;
        display:flex;
        flex-wrap:wrap;
        justify-content:space-around;
    }
    .flex_item {
        border: solid black 1px;
        width: 200px;
        height: 130px;
        font-size: 30px;
        text-align: center;
        padding:20px;
        margin: 10px;
        background-color: white;
        box-shadow: 3px 3px 3px gray;
        cursor:pointer;
    }

    .layout_split {
        display:flex;
    }
}

/* mobile */
@media screen and (max-width: 414px) {
    .layout_split {
        display: flex;
        flex-direction: column;
    }
    .flex_container {
        margin: 10px 0px;
        padding: 0px;
        display: flex;
        flex-direction: column;
    }
    .flex_item {
        border: solid black 1px;
        height: 130px;
        font-size: 26px;
        text-align: center;
        padding:10px;
        margin: 10px;
        background-color: white;
        box-shadow: 2px 2px 2px gray;
    }

    .mobile_margin {
        margin-bottom: 50px;
    }
}
</style>
